<template>
    <div class="info-tooltip">
        <div class="tooltip-header">Impostos</div>
        <div class="row">
            <p class="info-text"><strong>Origem:</strong> {{origin}}</p>
        </div>
        <div class="row">
            <div class="col-md-12">
                <vue-good-table
                    :columns="columnsTaxes" 
                    :rows="productTaxes" 
                    :pagination-options="{enabled: false}"
                    styleClass="vgt-table"
                >
                    <template slot="table-row" slot-scope="props">
                        <span v-if="props.column.field == 'icms' || props.column.field == 'ipi' || props.column.field == 'mva'">
                            {{formatPercent(props.formattedRow[props.column.field])}}
                        </span>
                        <span v-else-if="props.column.field == 'reduct'">
                            {{formatFloat(props.formattedRow[props.column.field])}}
                        </span>
                    </template>
                    <div slot="emptystate">Sem dados para exibição</div>
                </vue-good-table>
            </div>
        </div>
    </div>
</template>
<script>
import "vue-good-table/dist/vue-good-table.css";
import { VueGoodTable } from "vue-good-table";

export default {
    name: "ProductTaxesTooltip",
    props: [
        "productTaxes",
        "origin"
    ],
    components: {
        VueGoodTable
    },
    data(){
        return{
            columnsTaxes: [
                { label: "ICMS", field: "icms", tdClass: "align-center-td", thClass: "align-center-td"},
                { label: "Redução", field: "reduct", tdClass: "align-center-td", thClass: "align-center-td"},
                { label: "PPB", field: "ppb", tdClass: "align-center-td", thClass: "align-center-td"},
                { label: "IPI", field: "ipi", tdClass: "align-center-td", thClass: "align-center-td"},
                { label: "CFOP", field: "cfop", tdClass: "align-center-td", thClass: "align-center-td"},
                { label: "NCM", field: "ncm", tdClass: "align-center-td", thClass: "align-center-td"},
                { label: "MVA", field: "mva", tdClass: "align-center-td", thClass: "align-center-td"}
            ]
        }
    },
    methods:{
        formatPercent: function(v) {
            //formata valores floats para procentagem
            var formato = {
                minimumFractionDigits: 2,
                style: "percent",
            };
            return parseFloat(v/100).toLocaleString("pt-BR", formato);
        },
        formatFloat: function(v) {
            //formata valores floats para procentagem
            var formato = {
                minimumFractionDigits: 2,
            };
            return parseFloat(v).toLocaleString("pt-BR", formato);
        },
    }
}
</script>
